/**
 * D331's fallback order for `notice.text` — a wire object rather than a catalog entry, so it takes
 * its own reader rather than `t()`'s. `adding-a-locale.md` §6: a fallback is legitimate when the
 * translated artifact would cost more than it is worth or would be less trustworthy than the
 * original — the same argument that document already makes for the legal pages and the שעון שבת
 * locality labels, applied here to a sentence an operator typed once, in whichever language they
 * had, about an outage or a maintenance window.
 *
 * **Order: the resident's own locale, then 🔸 `en`, then the first key present** (R9 §4.5,
 * restated at `selogate-prd.md` §2 D331 and `docs/product/edge-cases.md`'s PEC-58).
 * `scripts/put-client-config.mjs` prints exactly this order back to the operator before it writes.
 *
 * By construction every `ClientConfigNotice` this function is handed has at least one key: the
 * server-strict parser in `packages/core` refuses an empty `text` (R9 §6), and the client-tolerant
 * reader in `document.ts` drops a notice to `undefined` rather than pass this function an empty
 * object. The `undefined` return here is a defensive fallback for a caller that bypassed that
 * reader — never an expected path from this client's own rail.
 */

export function resolveNoticeText(
  text: Readonly<Record<string, string>>,
  locale: string,
): string | undefined {
  const own = text[locale]
  if (own !== undefined) return own
  const en = text['en']
  if (en !== undefined) return en
  const firstKey = Object.keys(text)[0]
  return firstKey === undefined ? undefined : text[firstKey]
}
